import { $t } from '@/i18n';
import { getWithoutNilQuery } from '@/utils/path';
import { useRouter } from '@/router/useRouter';
import { aiProjectEditorRouteName } from '@/router/route-const';
import { projectAPI } from '@/modules/ai-page/backendAPI';
import { message } from './wuji-message';
export async function openAiProjectEditor(query = {}, newWindow = false) {
    const { router, route } = useRouter();
    const routeQuery = getWithoutNilQuery({
        ...query,
        projectid: query.projectid || route.value?.query?.projectid,
        branch: query.branch || route.value?.query?.branch,
    });
    let projectInfo;
    try {
        projectInfo = await projectAPI.getProjectInfo();
    }
    catch (error) {
        let { message: msg } = error;
        if (msg.trim() === 'forbidden') {
            msg = $t('k_6645596d');
        }
        message.error($t('k_61b58e50', { arg_0: msg }));
        throw error;
    }
    if (!projectInfo) {
        message.info($t('k_f8df9269'));
        try {
            await projectAPI.initializeProject();
        }
        catch (error) {
            let { message: msg } = error;
            if (msg.trim() === 'forbidden') {
                msg = $t('k_e3b6ad74');
            }
            message.error($t('k_c213ec27', { arg_0: msg }));
            throw error;
        }
        message.success($t('k_e48ac5b3'));
    }
    const url = router.value?.resolve({ name: aiProjectEditorRouteName, query: routeQuery })?.href;
    if (newWindow) {
        window.open(url, '_blank', 'noopener=yes');
    }
    else {
        window.location.href = url;
    }
}
